
const init = () => {

	const menuToggle = document.querySelector('.mobile-menu-toggle');
	const menu = document.querySelector('.wp-block-csccanada-faqs__menu');
	let menuIsOpen = false;
	if (!menuToggle && !menu){
		return;
	}


	// Toggle an element's class
	function toggleClass(el, classname) {
		el.classList.contains(classname)
			? el.classList.remove(classname)
			: el.classList.add(classname);
	}


	function toggleMenuOpen(){

		menuIsOpen = !menuIsOpen;
		toggleClass(document.body, '-mobile-faq-menu-open');
	}

	menuToggle.addEventListener('click', toggleMenuOpen);

};

init();
